"use client";

import ButtonIcon from "./icon";

import type { JSX } from "react";
import type { ButtonChangeLayoutProps } from "./types";

/**
 * ButtonChangeLayout Component
 *
 * A responsive button component used to toggle the sidebar navigation.
 * It renders a hamburger menu icon with responsive sizing and spacing.
 *
 * @param {ButtonChangeLayoutProps} props - The properties for the component.
 * @returns {JSX.Element} The rendered button element.
 */
const ButtonChangeLayout = ({
  onClick,
  sidebarIsOpen
}: ButtonChangeLayoutProps): JSX.Element => (
  <ButtonIcon
    onClick={onClick}
    className="block"
    aria-label={sidebarIsOpen ? "Close sidebar" : "Open sidebar"}
    aria-expanded={sidebarIsOpen}
  />
);

export default ButtonChangeLayout;
